import { rules, ruleSets } from '.';

const { isNotEmptyString } = rules;

export const getValidations = (inputs: Input[]): Validation[] =>
    inputs.map(({ args, inputId, label, type, required, value }: Input) => {
        const currentRules: Rule[] = ruleSets?.[type] ?? [];

        let ruleResults: RuleResult[] = [];
        let isRequiredAndEmpty = false;

        if (required) {
            const { test, errorMessage, name } = isNotEmptyString;
            const valid = test(value);

            if (!valid) {
                isRequiredAndEmpty = true;
            }

            ruleResults.push({ valid, errorMessage, name });
        }

        // If the field is required but empty, do not continue evaluating rules.
        if (!isRequiredAndEmpty) {
            ruleResults = currentRules.map((rule: Rule) => {
                const { test, errorMessage, name } = rule;
                const valid = test(value, args);

                return { valid, errorMessage, name };
            });
        }

        const isValid = ruleResults.every(
            (ruleResult: RuleResult): boolean => ruleResult.valid,
        );

        return { inputId, label, type, value, ruleResults, isValid };
    });
